import { Builder } from '@builder.io/react'
import type { Input } from '@builder.io/sdk'
import dynamic from 'next/dynamic'

import { BLOCK_NAMES } from '@/blocks/blockNames'
import { containerSpaceInBuilderInput } from '@/components/Container'
import { midiaTypeBuilderInput, imageBuilderInput } from '@/components/Media/constants.register'

const settings: Input = {
  name: 'settingsLink',
  friendlyName: 'Configurações Link',
  type: 'object',
  advanced: true,
  defaultValue: {
    label: 'acesse todos os parceiros',
    link: 'https://www.serasa.com.br/limpa-nome-online/parceiros/',
  },
  subFields: [
    {
      name: 'link',
      type: 'string',
      friendlyName: 'URL',
      helperText: 'Href link da pagina sem resultado de parceiros',
      required: true,
    },
    {
      name: 'label',
      type: 'string',
      friendlyName: 'Label',
      helperText: 'Label do link da pagina sem resultado de parceiros',
      required: true,
    },
  ],
}

Builder.registerComponent(
  dynamic<never>(() => import('.').then((mod) => mod.PartnerSearchListBlock)),
  {
    name: BLOCK_NAMES.list.searchPartner,
    inputs: [
      {
        ...containerSpaceInBuilderInput,
        advanced: true,
      },
      {
        ...settings,
      },

      {
        name: 'items',
        friendlyName: 'Parceiros',
        type: 'list',
        subFields: [
          {
            name: 'name',
            type: 'string',
          },
          {
            name: 'link',
            type: 'string',
            friendlyName: 'Link URL',
          },
          {
            name: 'midia',
            type: 'object',
            friendlyName: 'Mídia',
            subFields: [
              {
                ...midiaTypeBuilderInput,
                defaultValue: 'image',
                hideFromUI: true,
              },
              {
                ...imageBuilderInput,
              },
            ],
          },
        ],
      },
    ],
  },
)
